import { Stack, useTheme, useMediaQuery } from "@mui/material";
import { memo } from "react";
import { MultiplierSlot } from "./MultiplierSlot";
import type { MultiplierSlot as MultiplierSlotType } from "../types/schema";

interface MultiplierSlotsProps {
  slots: MultiplierSlotType[];
  winningIndex: number | null;
}

export const MultiplierSlots = memo(
  ({ slots, winningIndex }: MultiplierSlotsProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isSmallMobile = useMediaQuery("(max-width:1300px)");
    const isSmallTablet = useMediaQuery(
      "(min-width: 600px) and (max-width: 930px)"
    );
    const isLargeTablet = useMediaQuery(
      "(min-width: 931px) and (max-width: 1200px)"
    );

    const getSpacing = () => {
      if (isSmallMobile) return -1.9;
      if (isMobile) return 1;
      if (isSmallTablet) return -1.2; // 📱 manji iPad
      if (isLargeTablet) return -0.6; // 💻 iPad Pro
      return 0.4;
    };

    const getMarginTop = () => {
      if (isSmallMobile) return -6.0;
      if (isMobile) return -3;

      return -4;
    };
    const getWidth = () => {
      if (isMobile) return "90%";
      if (isSmallTablet) return "750px"; // manji iPad
      if (isLargeTablet) return "850px";
      return "600px"; // desktop širina
    };
    return (
      <Stack
        direction="row"
        spacing={getSpacing()}
        justifyContent="center"
        alignItems="center"
        sx={{
          mt: getMarginTop(),
          width: getWidth(), // ⬅️ koristi istu vrijednost

          px: isSmallMobile ? 0.5 : isMobile ? 1 : 2,
          position: "relative",
          zIndex: 3,
          left: "-5px",
        }}
      >
        {slots.map((slot, index) => (
          <MultiplierSlot
            key={index}
            value={slot.value}
            color={slot.color}
            isWinning={winningIndex === index}
            isActive={winningIndex === index}
          />
        ))}
      </Stack>
    );
  }
);

MultiplierSlots.displayName = "MultiplierSlots";
